export default "__VITE_ASSET__Drlmq8uA__"